import React, { useState } from 'react'
import ContentLoader from 'react-content-loader'
import { Row, Col } from '@navent-jobs/ui-kit/components/grid'

// mixins
import { LoaderContainer, PlaceholderData } from './mixins'

const FichaAvisoPlaceholder = () => {
  const [wrapperWidth, setWrapperWidth] = useState(0)
  return (
    <LoaderContainer ref={node => node && setWrapperWidth(node.offsetWidth)}>
      {/* Description */}
      <PlaceholderData>
        <ContentLoader
          speed={2}
          width={wrapperWidth}
          height={580}
          viewBox={`0 0 ${wrapperWidth} 580`}
          backgroundColor="#f3f3f3"
          foregroundColor="#d4d4d4"
        >
          <rect x="24" y="16" rx="4" ry="4" width="20" height="20" />
          <rect x="52" y="18" rx="4" ry="4" width={wrapperWidth * 0.1297} height="16" />
          <rect x="24" y="50" rx="4" ry="4" width="20" height="20" />
          <rect x="52" y="52" rx="4" ry="4" width={wrapperWidth * 0.2227} height="16" />

          <rect x="24" y="84" rx="4" ry="4" width={wrapperWidth * 0.9449} height="16" />
          <rect x="24" y="116" rx="4" ry="4" width={wrapperWidth * 0.9449} height="16" />
          <rect x="24" y="148" rx="4" ry="4" width={wrapperWidth * 0.7026} height="16" />
          <rect x="24" y="180" rx="4" ry="4" width={wrapperWidth * 0.9449} height="16" />
          <rect x="24" y="212" rx="4" ry="4" width={wrapperWidth * 0.9449} height="16" />
          <rect x="24" y="252" rx="4" ry="4" width={wrapperWidth * 0.9449} height="16" />
          <rect x="24" y="280" rx="4" ry="4" width={wrapperWidth * 0.9449} height="16" />
          <rect x="24" y="324" rx="4" ry="4" width={wrapperWidth * 0.9449} height="16" />
          <rect x="24" y="356" rx="4" ry="4" width={wrapperWidth * 0.2009} height="16" />
          <rect x="24" y="388" rx="4" ry="4" width={wrapperWidth * 0.9449} height="16" />
          <rect x="24" y="420" rx="4" ry="4" width={wrapperWidth * 0.8335} height="16" />

          {/* Data */}
          <path d={`M 16 452 h ${wrapperWidth * 0.954} v 1 H 16 z`} />

          {/* Primer columna */}
          <rect x={wrapperWidth * 0.0275} y="468" rx="4" ry="4" width="20" height="20" />
          <rect x={wrapperWidth * 0.0597} y="470" rx="4" ry="4" width={wrapperWidth * 0.0711} height="16" />
          <rect x={wrapperWidth * 0.0275} y="500" rx="4" ry="4" width="20" height="20" />
          <rect x={wrapperWidth * 0.0597} y="502" rx="4" ry="4" width={wrapperWidth * 0.2227} height="16" />
          <rect x={wrapperWidth * 0.0275} y="532" rx="4" ry="4" width="20" height="20" />
          <rect x={wrapperWidth * 0.0597} y="534" rx="4" ry="4" width={wrapperWidth * 0.1607} height="16" />
          {/* Segunda columna */}
          <rect x={wrapperWidth * 0.3624} y="468" rx="4" ry="4" width="20" height="20" />
          <rect x={wrapperWidth * 0.3946} y="470" rx="4" ry="4" width={wrapperWidth * 0.1297} height="16" />
          <rect x={wrapperWidth * 0.3624} y="500" rx="4" ry="4" width="20" height="20" />
          <rect x={wrapperWidth * 0.3946} y="502" rx="4" ry="4" width={wrapperWidth * 0.1871} height="16" />
          <rect x={wrapperWidth * 0.3624} y="532" rx="4" ry="4" width="20" height="20" />
          <rect x={wrapperWidth * 0.3946} y="534" rx="4" ry="4" width={wrapperWidth * 0.2227} height="16" />
          {/* Tercer columna */}
          <rect x={wrapperWidth * 0.696} y="468" rx="4" ry="4" width="20" height="20" />
          <rect x={wrapperWidth * 0.7282} y="470" rx="4" ry="4" width={wrapperWidth * 0.1102} height="16" />
        </ContentLoader>
      </PlaceholderData>

      {/* Aviso */}
      <PlaceholderData>
        <ContentLoader
          speed={2}
          width={wrapperWidth}
          height={248}
          viewBox={`0 0 ${wrapperWidth} 248`}
          backgroundColor="#f3f3f3"
          foregroundColor="#d4d4d4"
        >
          <path d="M 0 0 h 6 v 248 H 0 z" />
          <rect x="16" y="12" rx="4" ry="4" width="68" height="44" />
          <rect x="96" y="18" rx="2" ry="2" width="220" height="8" />
          <rect x="96" y="42" rx="2" ry="2" width="157" height="8" />
          <rect x={wrapperWidth * 0.8461} y="216" rx="4" ry="4" width={wrapperWidth * 0.1354} height="20" />
          <rect x="36" y="223" rx="2" ry="2" width="86" height="6" />
          <rect x="16" y="218" rx="4" ry="4" width="16" height="16" />
          <rect x="36" y="173" rx="2" ry="2" width="144" height="8" />
          <rect x="16" y="169" rx="4" ry="4" width="16" height="16" />
          <rect x="36" y="198" rx="2" ry="2" width="111" height="8" />
          <rect x="16" y="194" rx="4" ry="4" width="16" height="16" />
          <rect x="36" y="148" rx="2" ry="2" width="99" height="8" />
          <rect x="16" y="144" rx="4" ry="4" width="16" height="16" />
          <rect x="16" y="92" rx="2" ry="2" width={wrapperWidth * 0.9632} height="8" />
          <rect x="16" y="108" rx="2" ry="2" width={wrapperWidth * 0.9632} height="8" />
          <rect x="16" y="124" rx="2" ry="2" width="406" height="8" />
          <rect x="16" y="68" rx="2" ry="2" width="571" height="12" />
        </ContentLoader>
      </PlaceholderData>
    </LoaderContainer>
  )
}

export default FichaAvisoPlaceholder
